import { EJStatus } from '@cims-online/shared'
import { ExpandOptions } from 'components/CIMSTable/CIMSTableContext/types/expand'
import { HelpMessage } from 'utils/constants'
import { useEJLogContext } from '../../../EJLogContext'
import { EngineeringJudgement } from '../../../EJLogContext/types'

export function useExpand(): ExpandOptions<EngineeringJudgement> {
  const Help = HelpMessage.EngineeringJudgements.EJLog
  const { refetch, edit } = useEJLogContext()
  return {
    render: ({
      id,
      statusId,
      notes,
      ejToPayItemNoGeometries,
      type: { allowanceDescription },
      customFields,
      deleted,
    }) => {
      return {
        additionalInfo: [
          {
            label: 'Allowance Description',
            children: allowanceDescription,
            help: Help.AllowanceDescription,
          },
          {
            label: 'Notes',
            children: notes,
            help: Help.Notes,
          },
          {
            type: 'payItems',
            payItems: ejToPayItemNoGeometries.map(({ payItem }) => payItem),
            object: 'Engineering Judgement',
          },
        ],
        customFields: {
          recordInactive: deleted,
          alreadyDisabled:
            statusId === EJStatus.Closed.id
              ? { why: 'invalid status', statusName: EJStatus.Closed.name }
              : false,
          customFields,
          booleanValueOptions: {
            onCheck: async (booleanInput) => {
              await edit({
                variables: {
                  input: {
                    id,
                    customFields: { booleanInputs: [booleanInput] },
                  },
                },
              })
              refetch()
            },
          },
          listValueOptions: {
            onCheck: async (checkbox) => {
              await edit({
                variables: {
                  input: {
                    id,
                    customFields: { listInputs: { checkboxes: [checkbox] } },
                  },
                },
              })
            },
          },
        },
      }
    },
  }
}
